import axios from "axios";

export default {
    getSousCategories(){
        return axios.get(`/sous_categories/liste`);
    }
};
